import React from "react"
import styled from "styled-components"
import parse from "html-react-parser"
import Icon from "../atoms/icon"
import Whitebox from "../atoms/white-box"
import Text from "../atoms/text"
import { color } from "../../components/colors"
import { FlexBox } from "../../components/flexbox"
import { typography } from "../../components/typography"

const Employer = styled(FlexBox)`
  position: relative;
  overflow: hidden;
  border: 2px solid ${color.primary40};
  height: 100%;
  transition: background-color 0.3s ease;
  cursor: pointer;

  i,
  p {
    position: relative;
  }

  &:hover,
  &.active {
    background-color: ${color.primary40};
  }

  @media (min-width: 769px) {
    min-height: 200px;

    &:not(:nth-last-child(-n + 2)) {
      margin-bottom: 54px;
    }
  }
`

const Card = ({ className, data, icon, dataId, onClick }) => (
  <Employer
    className={className}
    column
    justify={"flex-start"}
    align={"center"}
    p="25px 15px"
    data-id={dataId}
    onClick={onClick}
    width={"100%"}
  >
    <Icon size="75px" p="9px" mb="16px" hidden showMD>
      <img src={data.uslugiIkona.sourceUrl} />
    </Icon>
    <FlexBox center minheightMD={"100px"}>
      <Text typography={typography.heading} center color={color.white}>
        {data.uslugiOpis}
      </Text>
    </FlexBox>
  </Employer>
)

const hexToRgb = hex => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  if (result) {
    var r = parseInt(result[1], 16)
    var g = parseInt(result[2], 16)
    var b = parseInt(result[3], 16)
    return r + "," + g + "," + b //return 23,14,45 -> reformat if needed
  }
  return null
}

export default Card
